import React from 'react';
import { FaLock, FaShieldAlt } from 'react-icons/fa';

const PaymentTrustStrip = () => {
  return (
    <div className="payment-trust" role="note">
      <div className="payment-trust__icon" aria-hidden>
        <FaShieldAlt />
      </div>
      <div className="payment-trust__copy">
        <p className="payment-trust__title">Secured by Razorpay</p>
        <p className="payment-trust__desc">
          <FaLock aria-hidden /> Your payment is encrypted. DigiRasa never stores card or UPI
          details.
        </p>
      </div>
    </div>
  );
};

export default PaymentTrustStrip;
